import type { Variants } from "framer-motion";

export const fadeUp: Variants = {
    hidden: { opacity: 0, y: 30 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
    },
};

export const blurClear: Variants = {
    hidden: { opacity: 0, y: 30, filter: "blur(12px)" },
    show: {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
    },
};

export const scaleIn: Variants = {
    hidden: { opacity: 0, scale: 0.85 },
    show: {
        opacity: 1,
        scale: 1,
        transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
    },
};

export const staggerContainer = (stagger = 0.15, delayChildren = 0.1): Variants => ({
    hidden: {},
    show: {
        transition: {
            staggerChildren: stagger,
            delayChildren,
        },
    },
});
